const Container = {
  baseStyle: {
    paddingX: "2rem",
  },
};

export default Container;
